// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__vcNDC","active":"Pagination_active__DDld0"};